<div class="main-card shadow-sm h-100">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex align-items-center gap-2">
      <span class="main-heading fw-smbold">Cash Summary</span>
    </div>
    @if (summaryList.length > 5) {
      <button class="btn view-all-btn d-flex align-items-center gap-1" (click)="viewAllSummary()">
        View all <fa-icon [icon]="faChevronRight" style="font-size: 10px;"></fa-icon>
      </button>
    }
  </div>

  <!-- Top Summary Cards -->
  <div class="row g-2 mb-3">
    <div class="col-6">
      <div class="top-card h-100 d-flex flex-column justify-content-between">
        <div>
          <div class="top-card-heading mb-1">Opening Balance</div>
          <div class="fw-bold text-dark" style="font-size: 14px;">{{ highlightcards.openingCash | number }}</div>
        </div>
        <div class="mt-2 pt-2 border-top">
          <div class="top-card-heading mb-1">Expense</div>
          <div class="fw-bold text-danger" style="font-size: 14px;">{{ highlightcards.cashExpenses | number }}</div>
        </div>
      </div>
    </div>
    
    <div class="col-6">
      <div class="top-card h-100 d-flex flex-column justify-content-between">
        <div>
          <div class="top-card-heading mb-1">Cash Received</div>
          <div class="fw-bold text-primary" style="font-size: 14px;">{{ highlightcards.cashFromSales | number }}</div>
        </div>
        <div class="mt-2 pt-2 border-top">
          <div class="top-card-heading mb-1">Closing Balance</div>
          <div class="fw-bold text-dark" style="font-size: 14px;">{{ highlightcards.closingCash | number }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="table-box">
    <table class="table custom-table border-0 mb-0">
      <thead>
        <tr>
          <th class="fw-smbold border-0">Account Name</th>
          <th class="fw-smbold border-0">Branch</th>
          <th class="text-end fw-smbold border-0">Amount</th>
        </tr>
      </thead>
      <tbody>
        <!-- Loader State -->
        @if (loader) {
          <tr>
            <td colspan="3" class="text-center py-4 border-0">
              <app-loader [loadingIcon]="loader"></app-loader>
            </td>
          </tr>
        }

        <!-- Error State -->
        @if (!loader && errMsg) {
          <tr>
            <td colspan="3" class="text-center py-4 border-0">
              <p class="text-danger mb-0 small fw-bold">{{ errMsg }}</p>
            </td>
          </tr>
        }

        <!-- Data State -->
        @if (!loader && !errMsg) {
          @for (item of summaryList | slice:0:5; track item) {
            <tr>
              <td class="td-col-1 border-0 text-break">{{ item.accountName }}</td>
              <td class="td-col-2 border-0">{{ item.companyName }}</td>
              <td class="text-end td-col-3 fw-bold border-0">
                  ₹{{ item.totalSales | number }}
              </td>
            </tr>
          }
        }

        <!-- Empty State -->
        @if (!loader && !errMsg && summaryList.length === 0) {
          <tr>
            <td colspan="3" class="text-center py-4 border-0">
              <p class="text-muted mb-0 small fw-bold">No records found</p>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<!-- Modal Template -->
<ng-template #summaryModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="fw-bold mb-0 main-heading">All Cash Summaries</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body p-2 p-md-4">
    <div class="table-responsive table-container pe-md-2 pe-1">
      <table class="table custom-table border-0 mb-0">
        <thead>
          <tr>
            <th class="fw-smbold border-0">Account Name</th>
            <th class="fw-smbold border-0">Branch</th>
            <th class="text-end fw-smbold border-0">Amount</th>
          </tr>
        </thead>
        <tbody>
          @if (summaryList.length > 0) {
            @for (item of summaryList; track item) {
              <tr>
                <td class="td-col-1 border-0 text-break">{{ item.accountName }}</td>
                <td class="td-col-2 border-0">{{ item.companyName }}</td>
                <td class="text-end td-col-3 fw-bold border-0">
                    ₹{{ item.totalSales | number }}
                </td>
              </tr>
            }
          }
          @if (summaryList.length === 0) {
            <tr>
              <td colspan="3" class="text-center py-4 border-0">
                <p class="text-muted mb-0 small fw-bold">No records found</p>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
